const MY_RECOGNITIONS_TABLE_LIMIT = 10;
const HOME_RECOGNITIONS_TABLE_LIMIT = 5;

const CONTACT_TYPE = {
  list: 'list',
  number: 'number',
  tags: 'tags'
};

const STARTING = 'starting';
const STARTING_ERROR = 'error_on_start';
const DRAFT = 'draft';
const READY_TO_SEND = 'readyToSend';
const PENDING_APPROVAL = 'pending_approval';
const APPROVED = 'approved';
const REJECTED = 'rejected';
const LIVE = 'live';
const EXPIRED = 'expired';
const ARCHIVED = 'archived';
const HERO = 'hero_dashboard';
const TEAMS = 'teams_app';

const RECOGNITION_STATUSES = {
  [STARTING]: STARTING,
  [STARTING_ERROR]: STARTING_ERROR,
  [DRAFT]: DRAFT,
  [READY_TO_SEND]: READY_TO_SEND,
  [PENDING_APPROVAL]: PENDING_APPROVAL,
  [APPROVED]: APPROVED,
  [REJECTED]: REJECTED,
  [LIVE]: LIVE,
  [EXPIRED]: EXPIRED,
  [ARCHIVED]: ARCHIVED
};

const SOURCE_TYPES = {
  [HERO]: HERO,
  [TEAMS]: TEAMS
};

const SOURCE_TYPES_ARRAY = Object.keys(SOURCE_TYPES);

const ACTIVE_FILTERS_BY_STATUS = {
  [READY_TO_SEND]: ['NEW_RECOGNITION_REVIEW_PAY'],
  [DRAFT]: [
    'NEW_RECOGNITION_GIFTS',
    'NEW_RECOGNITION_CONTACT_TYPE',
    'NEW_RECOGNITION_RECIPIENTS',
    'NEW_RECOGNITION_EXPERIENCE'
  ]
};

const CONTACTLESS_VERIFICATION_TYPES = {
  PHONE: 'phone',
  EMAIL_LIST: 'emailList',
  EMAIL_DOMAIN: 'emailDomain',
  NONE: 'none'
};

const EDITABLE_VERIFICATION_LIVE = [CONTACTLESS_VERIFICATION_TYPES.EMAIL_DOMAIN];

const RECOGNITION_CREATION_STEPS = {
  newRecognitionGifts: 'NEW_RECOGNITION_GIFTS',
  newRecognitionExperience: 'NEW_RECOGNITION_EXPERIENCE',
  newRecognitionRecipients: 'NEW_RECOGNITION_RECIPIENTS',
  newRecognitionContactType: 'NEW_RECOGNITION_CONTACT_TYPE',
  newRecognitionReviewPay: 'NEW_RECOGNITION_REVIEW_PAY'
};

const SEND_GIFT_FLOW_STEPS = {
  giftList: 'send-gift-gift-list',
  review: 'send-gift-review',
  checkout: 'send-gift-checkout'
};

const SEND_GIFT_REDIRECT_STATUSES = [
  RECOGNITION_STATUSES.starting,
  RECOGNITION_STATUSES.starting_error,
  RECOGNITION_STATUSES.pending_approval,
  RECOGNITION_STATUSES.approved,
  RECOGNITION_STATUSES.live,
  RECOGNITION_STATUSES.expired,
  RECOGNITION_STATUSES.archived
];

const SEND_GIFT_ROUTE_PATHS = {
  [SEND_GIFT_FLOW_STEPS.giftList]: 'SEND_GIFT_UPDATE_GIFT_LIST',
  [SEND_GIFT_FLOW_STEPS.review]: 'SEND_GIFT_REVIEW',
  [SEND_GIFT_FLOW_STEPS.checkout]: 'SEND_GIFT_CHECKOUT'
};

const NON_EDITABLE_RECOGNITION_STATUS = [STARTING, ARCHIVED];

export {
  ACTIVE_FILTERS_BY_STATUS,
  CONTACTLESS_VERIFICATION_TYPES,
  CONTACT_TYPE,
  EDITABLE_VERIFICATION_LIVE,
  HOME_RECOGNITIONS_TABLE_LIMIT,
  MY_RECOGNITIONS_TABLE_LIMIT,
  NON_EDITABLE_RECOGNITION_STATUS,
  RECOGNITION_CREATION_STEPS,
  RECOGNITION_STATUSES,
  SEND_GIFT_FLOW_STEPS,
  SEND_GIFT_REDIRECT_STATUSES,
  SEND_GIFT_ROUTE_PATHS,
  SOURCE_TYPES,
  SOURCE_TYPES_ARRAY
};
